import React from "react";
import SettingForm from "./settingsPage/SettingForm";
import SettingsList from "./settingsPage/SettingsList";
import useSettingsPageController from "./settingsPage/useSettingsPageController";

export default function SettingsPage() {
  const { t, settings, newSetting, error, handleChange, handleAddSetting } =
    useSettingsPageController();

  return (
    <div className="container">
      <h1>{t("settingsTitle")}</h1>
      <SettingForm
        setting={newSetting}
        error={error}
        t={t}
        onChange={handleChange}
        onAdd={handleAddSetting}
      />
      <SettingsList settings={settings} t={t} />
    </div>
  );
}
